import { AxiosError } from 'axios';
import { logInfo } from 'utils/logging';
import { getCSRFTOKEN } from 'utils/cookie/getCSRFToken';
import { axiosAPI } from 'lib/api';

type DeleteQuestionResponse = {
  success: boolean;
};

const deleteQuestion = async (questionSlug: string): Promise<DeleteQuestionResponse> => {
  const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN') || '';

  try {
    return await axiosAPI({
      url: `/otvety/api/questions/${questionSlug}`,
      method: 'DELETE',
      withCredentials: true,
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-TOKEN': csrf_token,
      },
    });
  } catch (error) {
    const e = error as AxiosError;
    logInfo(e.toString(), true);
    return { success: false };
  }
};

export default deleteQuestion;
